import { Injectable } from '@angular/core';
import { AppLoggingService } from './app-logging.service';
import { OPERATIONS } from '../constants/app-insight-constants';
import { PtzInfo } from 'src/app/main/core/models/live-view.model';

@Injectable({
  providedIn: 'root',
})
export class LoggerCommonService {
  constructor(private readonly apploggingService: AppLoggingService) {}

  trace(
    page: string,
    status?: string,
    user?: string,
    message?: any,
    streamEvent?: string,
    streamName?: string,
    wowzaResponse?: any
  ) {
    let customData = {};
    if (status) customData['Status'] = status;
    if (user) customData['User'] = user;
    if (message) customData['Message'] = message;
    if (streamEvent) customData['StreamEvent'] = streamEvent;
    if (streamName) customData['StreamName'] = streamName;
    if (wowzaResponse) customData['WowzaResponse'] = wowzaResponse;

    this.apploggingService.logTrace(page, customData);
  }

  trackEvent(page: string, event?: string) {
    let customData = {};
    if (event) customData['Event'] = event;

    this.apploggingService.logEvent(page, customData);
  }

  streamingTrace(page: string, siteName?:string, streamEvent?: string, cameraName?: string, streamName?: string, message?: any, isPTZ?: boolean, StreamUrl?: string, other?: any) {
    let customData = {};
    customData['SiteName'] = siteName;
    customData['StreamEvent'] = streamEvent;
    customData['CameraName'] = cameraName;
    customData['StreamName'] = streamName;
    customData['Message'] = message;
    customData['isPTZ'] = isPTZ;
    customData['StreamUrl'] = StreamUrl;
    customData['Other'] = other;

    this.apploggingService.logTrace(page, customData);
  }

  trackClick(page: string, cameraName?: string) {
    let customData = {};
    if (cameraName) customData['cameraName'] = cameraName;

    this.apploggingService.logEvent(`${page}_${OPERATIONS.Click}`, customData);
  }

  error(error: any) {
    this.apploggingService.logException(error);
  }

  logTrace( message: string, properties?: {[key: string]: any} ) {
    this.apploggingService.logTrace(message, properties);
  }

  streamDebugLog(siteName: string, cameraName: string, streamName: string, status: string | number, streamUrl: string, message: any) {
    let page = "Stream_Debug"
    let customData = {};
    customData['SiteName'] = siteName;
    customData['CameraName'] = cameraName;
    customData['StreamName'] = streamName;
    customData['Status'] = status;
    customData['StreamUrl'] = streamUrl;
    customData['Message'] = message;

    this.apploggingService.logTrace(page, customData);
  }

  ptzEvent(page: string, siteName?:string, ptzInfo?: PtzInfo, apiResponse?: any) {
    let customData = {};
    customData['SiteName'] = siteName;
    customData['CommandValue'] = ptzInfo?.parameter;
    customData['nvrId'] = ptzInfo?.nvrId;
    customData['deviceId'] = ptzInfo?.deviceId;
    customData['success'] = apiResponse?.success;
    customData['error'] = apiResponse?.error;
    customData['result'] = apiResponse?.result;

    this.apploggingService.logEvent(page, customData);
  }
}
